// extracted by mini-css-extract-plugin
export var boldCellText = "_7802ea01ef9e6deb5a3cb14c4da9923f-css";